export default "__VITE_ASSET__DzouJfi___"